module.exports = __webpack_public_path__ + "img/20221213024359576tog.d8be458a.jpg";